module.exports = __webpack_public_path__ + "static/media/mapbox.7575688a.jpg";